import { FormHelperText } from '@mui/material'
import { TimePicker as MuiTimePicker } from '@mui/x-date-pickers'
import moment from 'moment'
import React from 'react'

interface TimeFieldProps {
  disabled?: boolean
  error?: boolean
  helperText?: React.ReactNode
  label?: React.ReactNode
  name?: string
  /**
   * value: HH:mm (24-hour format) string or undefined.
   */
  onChange?: (value?: string) => void
  /**
   * hh:mm (24-hour format) string
   */
  value?: string
}

export default function TimeField({ disabled, error, helperText, name, onChange, label, value }: TimeFieldProps) {
  return (
    <>
      <MuiTimePicker
        disabled={disabled}
        onChange={(value, _context) => {
          if (onChange) {
            onChange(value?.format('HH:mm'))
          }
        }}
        label={label}
        value={value ? moment(`${moment().format('MM/DD/yyyy')} ${value}:00`) : null}
      />

      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </>
  )
}
